import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useAuth} from '#imports';
import {useProfileStore} from '~/store/profileStore';
import {useTranslationStore} from '~/store/translation/translationStore';

export const useProfilePageViewMode = () => {
    // Stores
    const {user} = useAuth();
    const {profile} = storeToRefs(useProfileStore());
    const {isTranslationActivated} = storeToRefs(useTranslationStore());

    // Computed
    const isEditionEnabled = computed((): boolean => profile.value?.editMode || false);
    const isTranslationEnabled = computed((): boolean => isTranslationActivated.value);
    const isRecommendationEnabled = computed((): boolean => !isEditionEnabled.value && profile.value?.accountId !== user?.id);

    return {
        // a-z
        isEditionEnabled,
        isRecommendationEnabled,
        isTranslationEnabled,
    };
};
